if (!customElements.get('sown-card-waitlist')) {
  customElements.define('sown-card-waitlist', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const dialog = this.querySelector('dialog');
      const form = this.querySelector('[data-waitlist-form]');
      const success = this.querySelector('[data-waitlist-success]');
      const error = this.querySelector('[data-waitlist-error]');
      const submit = form.querySelector('[type="submit"]');
      const opener = this.querySelector('[data-waitlist-open]');
      let pending = false;
      opener.addEventListener('click', () => {
        if (!pending) {
          form.hidden = false;
          success.hidden = true;
          error.textContent = '';
        }
        dialog.showModal();
      });
      this.querySelector('[data-waitlist-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => opener.focus());
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (pending || !form.reportValidity()) return;
        const email = form.elements.email.value.trim();
        const variant = form.elements.variant.value;
        if (!variant) return;
        pending = true;
        submit.disabled = true;
        form.elements.variant.disabled = true;
        form.elements.email.readOnly = true;
        submit.textContent = 'Saving...';
        error.textContent = '';
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 15000);
        try {
          // Back-in-stock capture only. No newsletter/list subscription request.
          const response = await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=TfvBHu', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', revision: '2026-07-15' },
            signal: controller.signal,
            body: JSON.stringify({ data: {
              type: 'back-in-stock-subscription',
              attributes: {
                channels: ['EMAIL'],
                profile: { data: { type: 'profile', attributes: { email } } }
              },
              relationships: { variant: { data: {
                type: 'catalog-variant', id: '$shopify:::$default:::' + variant
              } } }
            } })
          });
          if (response.status !== 202) {
            const failure = new Error('Capture failed');
            failure.status = response.status;
            throw failure;
          }
          form.hidden = true;
          success.hidden = false;
          success.focus();
          form.elements.email.value = '';
        } catch (failure) {
          error.textContent = failure.status === 400
            ? 'Please check your email address and try again. If the problem continues, contact hello@sownbeauty.com.'
            : 'We could not confirm your signup. Please try again, or contact hello@sownbeauty.com.';
        } finally {
          clearTimeout(timeout);
          pending = false;
          submit.disabled = false;
          form.elements.variant.disabled = false;
          form.elements.email.readOnly = false;
          submit.textContent = 'Notify me';
        }
      });
    }
  });
}
